import BaseNormalizer from "./BaseNormalizer";

const hotOrderUnitsNormalizer = Object.create(BaseNormalizer).init(
  ["id", "name", "images", "products.id", "products.images", "products.name"],
  ["orderUnitsProducts", "products"],
);

export default hotOrderUnitsNormalizer;
